module.exports = __webpack_public_path__ + "static/preset-header-2-a54fcfc50469341963f201c0b1d4df07.png";